/*
 * Our Beam design class. Defines the client-side logic for our design codes
 * Includes: bracing, self weight, load combos, services cases etc.
 */

 // valid configurations
 // north american steel -> AISC (LRFD, ASD)
 // wood -> NDS (LRFD, ASD)
 // european steel -> Simple Design
 // custom shape -> Simple Design
class BeamFlexureDesign {
    constructor() {
        //design and service combinations
        this.designType = "LRFD"; // LRFD, ASD, None
        this.loadCombination = null;
        this.serviceCases = null;
        this.loadCases = null;

        //service case optoins
        this.includeService = true;
        this.liveLoadLimit = 360;
        this.deadPlusLiveLoadLimit = 360;
        this.snowOrWindLoadLimit = 360;
        this.totalLoadLimit = 240;

        //self-weight
        this.includeSelfWeight = true;

        //bracing options
        this.bracingType = "continuous"; //continuous, equal, custom, unbraced
        this.customBraces = [];
        this.bracesAtInflectionPoints = false;
        this.inflectionBraces = [];
        this.useLambdaOrCd = false;
    }

    static load(json) {
        const o = Object.assign(new BeamFlexureDesign, json)
        o.loadCombination = Object.assign(new LoadCombination, json.loadCombination)
        o.serviceCases = Object.assign(new LoadCombination, json.serviceCases)
        o.loadCases = Object.assign(new LoadCombination, json.loadCases)
        return o
    }

    getBracingStartLocation() {
        if(this.customBraces.length < 1) { return 0; }
        return this.customBraces[0].x;    
    }

    getBraceSpacing() {
        if(this.customBraces.length < 2) { return 24; }
        return this.customBraces[1].x - this.customBraces[0].x;
    }

 }
